// Trading pairs constants for the application

export const TOP_CRYPTO_PAIRS = [
  // Top 50 cryptocurrencies by market cap (ordered by importance)
  { symbol: 'BTCUSDT', name: 'Bitcoin', type: 'crypto', active: true },
  { symbol: 'ETHUSDT', name: 'Ethereum', type: 'crypto', active: true },
  { symbol: 'BNBUSDT', name: 'BNB', type: 'crypto', active: true },
  { symbol: 'SOLUSDT', name: 'Solana', type: 'crypto', active: true },
  { symbol: 'USDCUSDT', name: 'USD Coin', type: 'crypto', active: true },
  { symbol: 'XRPUSDT', name: 'XRP', type: 'crypto', active: true },
  { symbol: 'DOGEUSDT', name: 'Dogecoin', type: 'crypto', active: true },
  { symbol: 'TONUSDT', name: 'Toncoin', type: 'crypto', active: true },
  { symbol: 'ADAUSDT', name: 'Cardano', type: 'crypto', active: true },
  { symbol: 'SHIBUSDT', name: 'Shiba Inu', type: 'crypto', active: true },
  { symbol: 'AVAXUSDT', name: 'Avalanche', type: 'crypto', active: true },
  { symbol: 'TRXUSDT', name: 'TRON', type: 'crypto', active: true },
  { symbol: 'WBTCUSDT', name: 'Wrapped Bitcoin', type: 'crypto', active: true },
  { symbol: 'LINKUSDT', name: 'Chainlink', type: 'crypto', active: true },
  { symbol: 'DOTUSDT', name: 'Polkadot', type: 'crypto', active: true },
  { symbol: 'BCHUSDT', name: 'Bitcoin Cash', type: 'crypto', active: true },
  { symbol: 'NEARUSDT', name: 'NEAR Protocol', type: 'crypto', active: true },
  { symbol: 'MATICUSDT', name: 'Polygon', type: 'crypto', active: true },
  { symbol: 'ICPUSDT', name: 'Internet Computer', type: 'crypto', active: true },
  { symbol: 'UNIUSDT', name: 'Uniswap', type: 'crypto', active: true },
  { symbol: 'LTCUSDT', name: 'Litecoin', type: 'crypto', active: true },
  { symbol: 'DAIUSDT', name: 'Dai', type: 'crypto', active: true },
  { symbol: 'ETCUSDT', name: 'Ethereum Classic', type: 'crypto', active: true },
  { symbol: 'RNDRUSDT', name: 'Render', type: 'crypto', active: true },
  { symbol: 'APTUSDT', name: 'Aptos', type: 'crypto', active: true },
  { symbol: 'HBARUSDT', name: 'Hedera', type: 'crypto', active: true },
  { symbol: 'FILUSDT', name: 'Filecoin', type: 'crypto', active: true },
  { symbol: 'ATOMUSDT', name: 'Cosmos', type: 'crypto', active: true },
  { symbol: 'XLMUSDT', name: 'Stellar', type: 'crypto', active: true },
  { symbol: 'VETUSDT', name: 'VeChain', type: 'crypto', active: true },
  { symbol: 'MKRUSDT', name: 'Maker', type: 'crypto', active: true },
  { symbol: 'INJUSDT', name: 'Injective', type: 'crypto', active: true },
  { symbol: 'SUIUSDT', name: 'Sui', type: 'crypto', active: true },
  { symbol: 'AAVEUSDT', name: 'Aave', type: 'crypto', active: true },
  { symbol: 'GRTUSDT', name: 'The Graph', type: 'crypto', active: true },
  { symbol: 'OPUSDT', name: 'Optimism', type: 'crypto', active: true },
  { symbol: 'ARBUSDT', name: 'Arbitrum', type: 'crypto', active: true },
  { symbol: 'THETAUSDT', name: 'Theta Network', type: 'crypto', active: true },
  { symbol: 'ALGOUSDT', name: 'Algorand', type: 'crypto', active: true },
  { symbol: 'FLOWUSDT', name: 'Flow', type: 'crypto', active: true },
  { symbol: 'SANDUSDT', name: 'The Sandbox', type: 'crypto', active: true },
  { symbol: 'MANAUSDT', name: 'Decentraland', type: 'crypto', active: true },
  { symbol: 'QNTUSDT', name: 'Quant', type: 'crypto', active: true },
  { symbol: 'FTMUSDT', name: 'Fantom', type: 'crypto', active: true },
  { symbol: 'AXSUSDT', name: 'Axie Infinity', type: 'crypto', active: true },
  { symbol: 'CHZUSDT', name: 'Chiliz', type: 'crypto', active: true },
  { symbol: 'GALAUSDT', name: 'Gala', type: 'crypto', active: true },
  { symbol: 'ENJUSDT', name: 'Enjin Coin', type: 'crypto', active: true },
  { symbol: 'XTZUSDT', name: 'Tezos', type: 'crypto', active: true },
  { symbol: 'NEOUSDT', name: 'Neo', type: 'crypto', active: true },
  { symbol: 'IOTAUSDT', name: 'IOTA', type: 'crypto', active: true }
];

export const CFD_INSTRUMENTS = [
  // Forex pairs - Raw format without slashes
  { symbol: 'EURUSD', name: 'EUR/USD', type: 'forex', active: true },
  { symbol: 'GBPUSD', name: 'GBP/USD', type: 'forex', active: true },
  { symbol: 'USDJPY', name: 'USD/JPY', type: 'forex', active: true },
  { symbol: 'USDCHF', name: 'USD/CHF', type: 'forex', active: true },
  { symbol: 'AUDUSD', name: 'AUD/USD', type: 'forex', active: true },
  { symbol: 'USDCAD', name: 'USD/CAD', type: 'forex', active: true },
  { symbol: 'NZDUSD', name: 'NZD/USD', type: 'forex', active: true },
  { symbol: 'EURJPY', name: 'EUR/JPY', type: 'forex', active: true },
  { symbol: 'GBPJPY', name: 'GBP/JPY', type: 'forex', active: true },
  { symbol: 'EURGBP', name: 'EUR/GBP', type: 'forex', active: true },

  // Commodities (expanded)
  { symbol: 'XAUUSD', name: 'Gold/USD', type: 'commodity', active: true },
  { symbol: 'XAGUSD', name: 'Silver/USD', type: 'commodity', active: true },
  { symbol: 'XPTUSD', name: 'Platinum/USD', type: 'commodity', active: true },
  { symbol: 'XPDUSD', name: 'Palladium/USD', type: 'commodity', active: true },
  { symbol: 'XCUUSD', name: 'Copper/USD', type: 'commodity', active: true },
  { symbol: 'ZNCUSD', name: 'Zinc/USD', type: 'commodity', active: true },
  { symbol: 'NIUSD', name: 'Nickel/USD', type: 'commodity', active: true },
  { symbol: 'ALUUSD', name: 'Aluminum/USD', type: 'commodity', active: true },
  { symbol: 'TINUSD', name: 'Tin/USD', type: 'commodity', active: true },
  { symbol: 'LEADUSD', name: 'Lead/USD', type: 'commodity', active: true },


  // Major Stocks
  { symbol: 'AAPL', name: 'Apple Inc.', type: 'stock', active: true },
  { symbol: 'TSLA', name: 'Tesla Inc.', type: 'stock', active: true },
  { symbol: 'AMZN', name: 'Amazon.com Inc.', type: 'stock', active: true },
  { symbol: 'MSFT', name: 'Microsoft Corporation', type: 'stock', active: true },
  { symbol: 'NVDA', name: 'NVIDIA Corporation', type: 'stock', active: true },
  { symbol: 'META', name: 'Meta Platforms Inc.', type: 'stock', active: true },
  { symbol: 'NFLX', name: 'Netflix Inc.', type: 'stock', active: true },
  { symbol: 'GOOGL', name: 'Alphabet Inc.', type: 'stock', active: true },
  { symbol: 'BA', name: 'Boeing Co.', type: 'stock', active: true },
  { symbol: 'JPM', name: 'JPMorgan Chase & Co.', type: 'stock', active: true }
];
